import { FC, useMemo } from 'react';

import { StarIcon } from '@smartshell/ui-kit';

import s from './Rate.module.scss';

const STARS_CONFIG: Array<boolean> = new Array(5).fill(false);

interface IRateProps {
  rate: number;
}
export const Rate: FC<IRateProps> = ({ rate }) => {
  const config = useMemo(
    () => STARS_CONFIG.map((isFilled, index) => index < rate),
    [rate]
  );

  return (
    <div className={s.container}>
      {config.map((isFilled, index) => (
        <StarIcon
          key={`rate-star-${index}`}
          size="s"
          color={isFilled ? 'violet' : 'gray'}
        />
      ))}
    </div>
  );
};
